

import React, { useState, useEffect } from "react";
import { FlipperTimer } from "../flipper-timer/flipper-timer";
import styles from "./Video.module.css";
import ResultVisuals from "./ResultVisuals";

const VideoBox = ({ playerA, playerB, iframeSrc, timerValue, gameType, resultData, poisonCard }) => {
  const [iframeError, setIframeError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [timerSize, setTimerSize] = useState(50);

  // Handle iframe load errors
  const handleIframeError = () => {
    setIframeError(true);
    setErrorMessage("Video stream unavailable");
  };

  // Reset error when src changes
  useEffect(() => {
    setIframeError(false);
    setErrorMessage("");
  }, [iframeSrc]);

  // Handle responsive timer size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setTimerSize(30);
      } else {
        setTimerSize(50);
      }
    };

    // Initial check
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={styles.videoBox}>
      {/* Timer overlay */}
      <div className={styles.timer}>
        <FlipperTimer size={timerSize} initialTime={timerValue || 0} />
      </div>

      {/* Player info / Result Visuals overlay */}
      <div className={styles.playerInfo}>
        {/* Dynamic Result Visuals */}
        {gameType ? (
          <ResultVisuals gameType={gameType} data={resultData} poisonCard={poisonCard} playerA={playerA} playerB={playerB} />
        ) : (
          /* Legacy/Fallback for older props */
          (playerA || playerB) && (
            <>
              <div className={styles.playerSection}>
                <div style={{fontSize: '14px', color:'white'}} className={styles.playerName}>Player A</div>
                <div className={styles.playerCards}>
                  {playerA?.cards?.map((card, index) => (
                    <img
                      key={`${index}-${card}`}
                      src={card}
                      style={{width:'35px', objectFit:'contain'}}
                      alt={`Player A card ${index + 1}`}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  )) || <div>No cards</div>}
                </div>
              </div>

              <div className={styles.playerSection}>
                <div style={{fontSize: '14px', color:'white'}} className={styles.playerName}>Player B</div>
                <div className={styles.playerCards}>
                  {playerB?.cards?.map((card, index) => (
                    <img
                      key={`${index}-${card}`}
                      src={card}
                      style={{width:'35px', objectFit:'contain'}}
                      alt={`Player B card ${index + 1}`}
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                    />
                  )) || <div>No cards</div>}
                </div>
              </div>
            </>
          )
        )}
      </div>

      {/* Video iframe */}
      <div className={styles.videoframe}>
        {iframeError ? (
          <div className={styles.errorMessage}>
            <div>🎥</div>
            <div>{errorMessage}</div>
            <div style={{ fontSize: '0.9rem', marginTop: '0.5rem', opacity: 0.8 }}>
              Please check your connection or try again later
            </div>
          </div>
        ) : (
          <iframe
            src={iframeSrc}
            className={styles.iframe}
            title="Live Stream"
            allowFullScreen
            onError={handleIframeError}
            onLoad={(e) => {
              // Check if iframe content shows error
              try {
                const iframeDoc = e.target.contentDocument || e.target.contentWindow.document;
                if (iframeDoc && iframeDoc.body && iframeDoc.body.innerText.includes('not allowed')) {
                  handleIframeError();
                  setErrorMessage("Stream access not allowed");
                }
              } catch (error) {
                // Cross-origin restrictions prevent access - this is normal
                console.log('Cannot access iframe content due to CORS');
              }
            }}
          />
        )}
      </div>


    </div>
  );
};

export default VideoBox;